export default __webpack_public_path__ + "static/media/chevron-up.49252166.svg";